// extracted by mini-css-extract-plugin
export default {"container":"rSEf8","avatar-wrapper":"RS9Fj","avatar":"tvAy0","date":"taHXx","content-wrapper":"F4VG4"};